// Reopen Shopify's native preferences dialog without changing saved consent.
document.addEventListener('click', event => {
  const button = event.target.closest('[data-renly-cookie-preferences]');
  if (!button || !window.privacyBanner?.showPreferences) return;
  window.privacyBanner.showPreferences().catch(() => {});
});

// Keep native consent policy links on the current market domain.
if (['renlyfrance.fr', 'www.renlyfrance.fr', 'renlysuomi.fi', 'www.renlysuomi.fi'].includes(location.hostname)) {
  const localPolicyLinks = () => {
    document.querySelectorAll('#shopify-pc__banner a[href], #shopify-pc__prefs a[href]').forEach(link => {
      const target = new URL(link.href, location.origin);
      if (target.hostname === 'renlysverige.se' && target.pathname.endsWith('/policies/privacy-policy')) {
        link.href = `${location.origin}/policies/privacy-policy`;
      }
    });
  };
  new MutationObserver(localPolicyLinks).observe(document.body, { childList: true, subtree: true });
  localPolicyLinks();
}
